type Falsy = false | 0 | '' | null | undefined;
type Result<T> = T extends Falsy ? string : T;

export function displayText<T>(input: T): Result<T> {
  if (typeof input === 'string') {
    return (input || '-') as Result<T>;
  }
  // `??` is a more secure handle situation when we have 0 where ternary operator will display `-`
  return (input ?? '-') as Result<T>;
}
